import { useMutation } from '@tanstack/react-query';
import { CALCULATIONS_MUTATION_KEY } from 'services/calculations/mutationKey';

import { CashFlowApi } from '../cashFlow.api';

export const useGetLiabilitiesCalculation = () => {
  return useMutation({
    mutationKey: CALCULATIONS_MUTATION_KEY,
    mutationFn: CashFlowApi.getLiabilitiesCalculation,
  });
};
